<template>
  <v-select
    :items="months"
    :label="label"
    :value="value"
    item-text="name"
    item-value="key"
    @input="$emit('input', $event)"
  />
</template>

<script>
import { MonthMapper } from '@/utils/datetime'

export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    months() {
      return MonthMapper.getSelectItems()
    }
  },
  created() {
    // Set initial value to current month
    this.$emit('input', MonthMapper.getCurrentMonthIndex())
  }
}
</script>
